export function initGlobal() {
    const BANNER_DISMISS_DAYS = 7; // 1 week

    document.querySelectorAll('.c_top-banner').forEach(function (banner) {
        const closeButton = banner.querySelector('button');

        if (closeButton) {
            closeButton.addEventListener('click', function () {
                const expires = new Date(Date.now() + BANNER_DISMISS_DAYS * 24 * 60 * 60 * 1000).toUTCString();
                document.cookie = 'banner_dismissed_' + banner.dataset.bannerKey + '=1; expires=' + expires + '; path=/';

                banner.style.overflow = 'hidden';
                banner.style.transition = 'max-height 0.3s ease-out, opacity 0.3s ease-out';
                banner.style.maxHeight = banner.scrollHeight + 'px';

                requestAnimationFrame(() => {
                    banner.style.maxHeight = '0';
                    banner.style.opacity = '0';
                });

                setTimeout(() => {
                    banner.remove();
                }, 300);
            });
        }
    });

    const clinicSelectBtn = document.getElementById('clinicSelectBtn');
    if (clinicSelectBtn) {
        clinicSelectBtn.addEventListener('click', function () {
            const select = document.getElementById('clinicSelect');
            if (!select) return;
            const selected = select.options[select.selectedIndex];
            const url = selected ? selected.getAttribute('data-url') : null;
            if (url) {
                window.location.href = url;
            }
        });
    }
}
